const specialRegExSymbols = ["/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\"];
const specialRegExSymbolsRegEx = new RegExp(`(\\${specialRegExSymbols.join("|\\")})`, "gim");

const escapeForRegex = (text: string): string => text.replace(specialRegExSymbolsRegEx, "\\$1");

export default escapeForRegex;
